module.exports = __webpack_public_path__ + "img/Innovative.310a0455.png";